import React from "react";
import { Stack, Typography } from "@mui/material";

export const cardSx = { p: 3, borderRadius: 2, height: "100%" };

export const CardHeading = ({ id, title, helper, children }) => (
  <>
    <Stack direction="row" alignItems="center" spacing={1}>
      <Typography id={id} component="h2" variant="subtitle1" fontWeight={600}>
        {title}
      </Typography>
      {children}
    </Stack>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
      {helper}
    </Typography>
  </>
);
